import React, { useState, useEffect } from 'react';
import { FaPhone, FaEnvelope, FaInstagram, FaArrowUp, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showScrollTop, setShowScrollTop] = useState(false);

  const quickLinks = [
    { name: 'Início', href: '#home' },
    { name: 'Serviços', href: '#services' },
    { name: 'Portfólio', href: '#portfolio' },
    { name: 'Sobre', href: '#about' },
    { name: 'Contato', href: '#contact' }
  ];

  const services = [
    'Projetos Residenciais',
    'Projetos Comerciais',
    'Projetos de Reforma',
    'Regularização de Imóveis',
    'Aprovação na Prefeitura'
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShowScrollTop(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '5519993489551';
    const message = 'Olá! Gostaria de saber mais sobre os serviços de arquitetura.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleInstagramClick = () => {
    const instagramUrl = 'https://www.instagram.com/arq.biancapaulino/';
    window.open(instagramUrl, '_blank');
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-main">
          <div className="container">
            <div className="footer-content">
              <div className="footer-section">
                <div className="footer-logo">
                  <h3>Bianca Paulino</h3>
                  <p>Arquitetura & Interiores</p>
                </div>
                <p className="footer-description">
                  Transformando sonhos em arquitetura com criatividade, 
                  técnica e paixão por criar espaços únicos e funcionais.
                </p>
                <div className="footer-social">
                  <a href="https://www.instagram.com/arq.biancapaulino/" className="social-link">
                    <FaInstagram />
                  </a>
                </div>
              </div>

              <div className="footer-section">
                <h4>Links Rápidos</h4>
                <ul className="footer-links">
                  {quickLinks.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="footer-section">
                <h4>Nossos Serviços</h4>
                <ul className="footer-links">
                  {services.map((service, index) => (
                    <li key={index}>
                      <span>{service}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="footer-section">
                <h4>Contato</h4>
                <div className="footer-contact">
                  <a href="tel:+5519993489551" className="contact-item">
                    <span className="contact-icon"><FaPhone /></span>
                    <span>(19) 99348-9551</span>
                  </a>
                  <a href="mailto:arq.biancapaulino@gmail.com" className="contact-item">
                    <span className="contact-icon"><FaEnvelope /></span>
                    <span>arq.biancapaulino@gmail.com</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="footer-bottom-content">
              <p>&copy; {currentYear} Bianca Paulino</p>
              <div className="footer-legal">
                <p>
                  Desenvolvido por <a 
                    href="https://www.joaopedrobatistadev.com.br/" 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    João Pedro Batista Dev
                  </a>. Todos os direitos reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showScrollTop && (
        <button 
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Voltar ao topo"
        >
          <FaArrowUp />
        </button>
      )}

      <button 
        className="whatsapp-floating-button"
        onClick={handleWhatsAppClick}
        aria-label="Entrar em contato via WhatsApp"
      >
        <span className="whatsapp-icon">
          <FaWhatsapp />
        </span>
        <span className="whatsapp-text">WhatsApp</span>
      </button>

      <button 
        className="instagram-floating-button"
        onClick={handleInstagramClick}
        aria-label="Seguir no Instagram"
      >
        <span className="instagram-icon">
          <FaInstagram />
        </span>
        <span className="instagram-text">Instagram</span>
      </button>
    </>
  );
};

export default Footer;
